import { useCallback, useState } from "react";

export const useForceRerender = () => {
  const [_, setValue] = useState(true);

  return useCallback(() => setValue((prev) => !prev), []);
};
